// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3adacf6","389":"bfc18f00","732":"a9230885","977":"d29aaf9a"}[chunkId] + ".chunk.js";
};